import React from "react";
import "./TrendingTechHighlights.scss";
import ContentSection from "../components/ContentSection";
import SectionHeader from "../components/SectionHeader";
import TwoColumnLayout from "../components/TwoColumnLayout";
import TT_IMAGE from "../assets/images/trending-tech.png";

const TrendingTechHighlights: React.FC = () => {
  const leftContent = (
    <div className="trending-tech-highlights-content">
      <p>
        The Last Mile (TLM) prioritizes continuous education and professional
        development for their workforce, recognizing that staying current with
        rapidly evolving technology and best practices is essential for
        effectively serving their mission. A key component of this commitment
        includes enrolling staff in Google’s AI Essentials course, a
        comprehensive 5-7 hour self-paced program that teaches foundational AI
        concepts, practical application of generative AI tools, effective
        prompting techniques, and responsible AI usage.{" "}
      </p>
      <p>
        This Google-certified training, developed by AI experts at Google,
        enables TLM staff to boost productivity, enhance their work
        capabilities, and stay ahead of the AI curve through hands-on experience
        with real-world workplace scenarios. The organization invests in
        upskilling their team members across various domains, from cutting-edge
        technology training to program delivery, reentry services, and community
        partnerships, ensuring that staff can provide the highest quality
        support and remain at the forefront of innovation in justice reform and
        workforce development.
      </p>
    </div>
  );

  const rightContent = (
    <div className="trending-tech-highlights-right">
      <img src={TT_IMAGE} alt="" className="tth-image" />
    </div>
  );

  return (
    <ContentSection className="trending-tech-highlights-section">
      <SectionHeader
        title="Highlights from the Field"
        description="The Last Mile"
      />
      <TwoColumnLayout leftContent={leftContent} rightContent={rightContent} />
    </ContentSection>
  );
};

export default TrendingTechHighlights;
